import { ErrorBoundary, setUser } from '@sentry/react';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import Async from 'components/Async';
import PushNotificationsManager from 'components/PushNotificationsManager';
import AppointmentsRoute from 'modules/Appointments';
import Books from 'modules/Books/route';
import CertificatesRoute from 'modules/CertificatesRoute';
import Chat from 'modules/Chat';
import ErrorPage from 'modules/Error';
import GradeBook from 'modules/GradeBook/routing';
import HomePageRoute from 'modules/Home/route';
import NewsRoute from 'modules/News/route';
import PoliciesRoute from 'modules/Policies/route';
import ProfileRoute from 'modules/Profile';
import ProgramsRoute from 'modules/Programs';
import ReportRoute from 'modules/Report';
import store from 'store';
import isCampusApp from 'utils/isCampusApp';

import ServiceRouter from '@common/components/ServiceRouter';
import { ROUTES, getRoute } from '@common/constants/CampusRoutes';

import Layout from './components/Layout';

function FallbackComponent({ resetError, error }: any) {
	return <ErrorPage resetError={resetError} error={error} />;
}

function App() {
	useEffect(() => {
		if (store.auth?.user?.email) {
			setUser({
				email: store.auth.user.email,
				id: store.auth.user.sub,
			});
		}
	}, [store.auth?.user?.email]);

	useEffect(() => {
		store.fetch();
	}, []);

	return (
		<Async loading={store.loading}>
			{!isCampusApp() && <PushNotificationsManager />}
			<Layout>
				<ErrorBoundary fallback={FallbackComponent}>
					<Routes>
						<Route path="/*" element={<HomePageRoute />} />
						<Route path="/chat/*" element={<Chat />} />
						<Route path={`${ROUTES.HOME}/*`} element={<HomePageRoute />} />
						<Route path={`${ROUTES.NEWS}/*`} element={<NewsRoute />} />
						<Route path={`${ROUTES.POLICIES}/*`} element={<PoliciesRoute />} />
						<Route path={`${ROUTES.BOOKS}/*`} element={<Books />} />
						<Route path={`${ROUTES.PROGRAMS}/*`} element={<ProgramsRoute />} />
						<Route
							path={`${ROUTES.GRADEBOOK}/*`}
							element={
								<ServiceRouter academy={<Navigate to={getRoute(['HOME'])} replace />}>
									<GradeBook />
								</ServiceRouter>
							}
						/>
						<Route
							path={`${ROUTES.REPORT}/*`}
							element={
								<ServiceRouter lyceum={<ReportRoute />} academy={<ReportRoute />}>
									<Navigate to={getRoute(['HOME'])} />
								</ServiceRouter>
							}
						/>
						<Route
							path={`${ROUTES.CERTIFICATES}/*`}
							element={
								<ServiceRouter academy={<CertificatesRoute />}>
									<Navigate to={getRoute(['HOME'])} replace />
								</ServiceRouter>
							}
						/>

						<Route
							path={`${ROUTES.APPOINTMENTS}/*`}
							element={
								<ServiceRouter international={<Navigate to={getRoute(['HOME'])} replace />}>
									<AppointmentsRoute />
								</ServiceRouter>
							}
						/>
						<Route path={`${ROUTES.PROFILE}/*`} element={<ProfileRoute />} />
					</Routes>
				</ErrorBoundary>
			</Layout>
		</Async>
	);
}

export default observer(App);
